import type { DataTableFilterField } from '@/components/data-table/types'
import { field, createSchema } from '@/lib/store/schema'
import type { ChronicConditionRecord, LabResultRecord } from '../types'

export const labResultsFilterFields: DataTableFilterField<LabResultRecord>[] = [
  { label: 'Client', value: 'patient_name', type: 'input', defaultOpen: true },
  { label: 'Test', value: 'test_name', type: 'input', defaultOpen: true },
  { label: 'Result', value: 'result_raw', type: 'input', defaultOpen: true },
  { label: 'Observed', value: 'observed_at', type: 'timerange' },
  { label: 'Test Code', value: 'test_code', type: 'input' },
  { label: 'Lab', value: 'lab_vendor', type: 'input' },
]

export const chronicConditionsFilterFields: DataTableFilterField<ChronicConditionRecord>[] =
  [
    {
      label: 'Client',
      value: 'patient_name',
      type: 'input',
      defaultOpen: true,
    },
    {
      label: 'Condition',
      value: 'condition_description',
      type: 'input',
      defaultOpen: true,
    },
    {
      label: 'Code',
      value: 'condition_code',
      type: 'input',
      defaultOpen: true,
    },
    { label: 'Effective Date', value: 'effective_date', type: 'timerange' },
    { label: 'Code System', value: 'classification_system', type: 'input' },
  ]

export const labResultsSchema = createSchema({
  patient_name: field.string().default(null),
  test_name: field.string().default(null),
  result_raw: field.string().default(null),
  observed_at: field.array(field.timestamp()).delimiter(',').default([]),
  test_code: field.string().default(null),
  lab_vendor: field.string().default(null),
})

export const chronicConditionsSchema = createSchema({
  patient_name: field.string().default(null),
  condition_description: field.string().default(null),
  condition_code: field.string().default(null),
  effective_date: field.array(field.timestamp()).delimiter(',').default([]),
  classification_system: field.string().default(null),
})
